import React from "react";
import { useTranslation } from "react-i18next";

import { CustomInput } from "./CustomInput";
import ColorSelector from "./ColorSelector";
import ImageSelector from "./ImageSelector";
import ThemeSelector from "./ThemeSelector";
import ToolTip from "../../../../parts/tooltip-portal";
import SvgIcon from "../../../../parts/SvgIcon";

export const StorefrontBrandingSection = ({
  active = false,
  handleChange,
  handleSwitch,
  state,
  validateYoutubeLink,
}) => {
  const { t } = useTranslation("dashboard");
  const {
    bannerChanged,
    bannerImg,
    communityLink,
    descriptionSEO,
    facebookLink,
    favicon = {},
    faviconChanged,
    formBannerImg,
    formFavicon = {},
    formPhoneScreenImg,
    formPreviewImg,
    instagramHandle,
    instagramLink,
    introduction,
    introVideo,
    marketingSite,
    phoneScreenChanged,
    phoneScreenImg = {},
    previewImg,
    previewImgChanged,
    storefrontMainColor,
    storefrontSecondaryTextColor,
    storefrontTheme,
    twitterLink,
    youtubeLink,
  } = state;
  return (
    <div
      style={{
        display: active ? "block" : "none",
      }}
      className="storefront-section"
    >
      <article>
        <p className="s1">{t("branding.storefrontSetting")}</p>
        <section>
          <div className="left-column">
            <label>{t("branding.storefrontTheme")}</label>
            <ThemeSelector
              value={storefrontTheme}
              inputName="storefrontTheme"
              label={t("branding.storefrontTheme")}
              onChange={handleSwitch}
              isStorefront
              extraMargin
            />
            <ColorSelector
              storefrontMainColor={storefrontMainColor}
              storefrontSecondaryTextColor={storefrontSecondaryTextColor}
              onChange={handleSwitch}
              onChangeColor={handleChange}
            />
          </div>
          <div className="right-column ">
            {
              <img
                src={
                  storefrontTheme === "dark"
                    ? "/img/push-storefront-dark.png"
                    : "/img/push-storefront-light.png"
                }
              />
            }
          </div>
        </section>
      </article>
      <article className="content">
        <p className="s1">{t("branding.content")}</p>
        <section>
          <div className="left-side">
            <label>{t("branding.introduction")}</label>
            <textarea
              name="introduction"
              className="textarea-input introduction"
              placeholder={t("branding.introductionPlaceholder")}
              value={introduction}
              onChange={handleChange}
              sz="large"
            ></textarea>
          </div>
          <div className="right-side">
            <header>
              <label>{t("branding.descriptionSeo")}</label>
              <ToolTip
                body={[t("branding.descriptionSeoTooltip")]}
              >
                <SvgIcon src="/img/new-icons/question-circle.svg" />
              </ToolTip>
            </header>
            <textarea
              name="descriptionSEO"
              className="textarea-input"
              placeholder={t("branding.myDescriptionSeo")}
              value={descriptionSEO}
              onChange={handleChange}
              maxLength={160}
              sz="large"
            />
          </div>
        </section>
      </article>
      <article>
        <p className="s1">{t("branding.links")}</p>
        <section>
          <div className="left-side">
            <header>
              <label>{t("branding.marketingSiteHomepage")}</label>
              <ToolTip
                body={`${t("branding.marketingSiteTooltip1")}\n${t(
                  "branding.marketingSiteTooltip2"
                )}`}
              >
                <SvgIcon src="/img/new-icons/question-circle.svg" />
              </ToolTip>
            </header>
            <CustomInput
              name="marketingSite"
              onChange={handleChange}
              value={marketingSite}
              placeholder="http://"
            />

            <header>
              <label style={!validateYoutubeLink() ? { color: "#e90b34" } : {}}>
                {t("branding.introVideoOptional")}
              </label>
              <ToolTip body={t("branding.introVideoTooltip")}>
                <SvgIcon src="/img/new-icons/question-circle.svg" />
              </ToolTip>
              {!validateYoutubeLink() && (
                <ToolTip body={t("branding.introVideoInvalidTooltip")}>
                  <img
                    width={16}
                    height={16}
                    className="help-icon"
                    src="/img/svg/error-red-exclamation.svg"
                  />
                </ToolTip>
              )}
            </header>
            <CustomInput
              name="introVideo"
              onChange={handleChange}
              value={introVideo}
              placeholder={t("branding.linkToVideo")}
            />
          </div>

          <div className="right-side">
            <header>
              <label>{t("branding.communityLinkOptional")}</label>
              <ToolTip
                body={`${t("branding.communityLinkTooltip1")}\n${t(
                  "branding.marketingSiteTooltip2"
                )}`}
              >
                <SvgIcon src="/img/new-icons/question-circle.svg" />
              </ToolTip>
            </header>
            <CustomInput
              name="communityLink"
              onChange={handleChange}
              value={communityLink}
              placeholder="https://facebook.com/groups/mystrengthbook"
            />
          </div>
        </section>
      </article>
      <article className=" social-wrapper">
        <p className="s1">{t("branding.socialLinks")}</p>
        <section>
          <div className="left-side">
            <label>{t("branding.instagramHandle")}</label>
            <CustomInput
              name="instagramHandle"
              placeholder="yourhandle"
              value={instagramHandle}
              onChange={handleChange}
            />
            <label>{t("branding.instagram")}</label>
            <CustomInput
              name="instagramLink"
              placeholder="https://mystrengthbook.com"
              value={instagramLink}
              onChange={handleChange}
            />
            <label>{t("branding.twitter")}</label>
            <CustomInput
              name="twitterLink"
              placeholder="https://mystrengthbook.com"
              value={twitterLink}
              onChange={handleChange}
            />
          </div>
          <div className="right-side">
            <label>{t("branding.youtube")}</label>
            <CustomInput
              name="youtubeLink"
              placeholder="https://mystrengthbook.com"
              value={youtubeLink}
              onChange={handleChange}
            />
            <label>{t("branding.facebook")}</label>
            <CustomInput
              name="facebookLink"
              placeholder="https://mystrengthbook.com"
              value={facebookLink}
              onChange={handleChange}
            />
          </div>
        </section>
      </article>
      <article className="wrapper images-wrapper">
        <p className="s1">{t("branding.graphics")}</p>
        <section>
          <ImageSelector
            selectorTitle={t("branding.uploadBanner")}
            subInfo={
              <div>
                <span>{t("branding.imageFormatsJpgPng")}</span>
                <span>{t("branding.bannerDimensions")}</span>
              </div>
            }
            title={t("branding.banner")}
            id="Banner"
            info={t("branding.bannerDimensions")}
            //   subInfo="Recommended"
            buttonTitle={t("branding.editLogo")}
            imageDimensions={{
              marginTop: 0,
            }}
            inputName="customBranding[bannerImg]"
            imageInputs={[
              { name: "bannerChanged", value: bannerChanged },
              { name: "formBannerImgFile", value: formBannerImg.file || "" },
              { name: "formBannerImgType", value: formBannerImg.type || "" },
              { name: "formBannerImgName", value: formBannerImg.name || "" },
              {
                name: "formBannerImgS3Path",
                value: formBannerImg.s3Path,
              },
            ]}
            value={bannerImg}
            onChange={handleChange}
            showButton={false}
            toolTipTextBody={t("branding.requiredSizeBanner")}
          />
          <ImageSelector
            title={t("branding.phoneScreen")}
            id="Phone Screen"
            selectorTitle={t("branding.uploadImage")}
            subInfo={
              <div>
                <span>{t("branding.imageFormatsJpgPng")}</span>
                <span>{t("branding.maxSize800kb")}</span>
              </div>
            }
            buttonTitle={t("common:edit")}
            imageDimensions={{
              marginTop: 0,
            }}
            inputName="customBranding[phoneScreenImg]"
            imageInputs={[
              { name: "phoneScreenChanged", value: phoneScreenChanged },
              {
                name: "formPhoneScreenImgFile",
                value: formPhoneScreenImg.file || "",
              },
              {
                name: "formPhoneScreenImgType",
                value: formPhoneScreenImg.type || "",
              },
              {
                name: "formPhoneScreenImgName",
                value: formPhoneScreenImg.name || "",
              },
              {
                name: "formPhoneScreenImgS3Path",
                value: formPhoneScreenImg.s3Path,
              },
            ]}
            value={phoneScreenImg}
            onChange={handleChange}
            showButton={false}
            toolTipTextBody={t("branding.maxSize800kbTooltip")}
          />
          <ImageSelector
            title={t("branding.customLinkPreview")}
            id="Preview"
            info={t("branding.previewDimensions")}
            selectorTitle={t("branding.uploadImage")}
            subInfo={
              <div>
                <span>{t("branding.imageFormatsJpgPng")}</span>
                <span>{t("branding.maxSize800kb")}</span>
              </div>
            }
            buttonTitle={t("common:edit")}
            imageDimensions={{
              marginTop: 0,
            }}
            inputName="customBranding[previewImg]"
            imageInputs={[
              { name: "previewImgChanged", value: previewImgChanged },
              {
                name: "formPreviewImgFile",
                value: formPreviewImg.file || "",
              },
              {
                name: "formPreviewImgType",
                value: formPreviewImg.type || "",
              },
              {
                name: "formPreviewImgName",
                value: formPreviewImg.name || "",
              },
              {
                name: "formPreviewImgS3Path",
                value: formPreviewImg.s3Path,
              },
            ]}
            value={previewImg}
            onChange={handleChange}
            allowedExtensions="image/jpeg,image/png"
            showButton={false}
            toolTipTextBody={t("branding.requiredSizePreview")}
          />
          <ImageSelector
            title={t("branding.favicon")}
            id="Favicon"
            selectorTitle={t("branding.uploadImage")}
            subInfo={
              <div>
                <span>{t("branding.imageFormatsJpgPng")}</span>
                <span>{t("branding.maxSize800kb")}</span>
              </div>
            }
            inputName="customBranding[favicon]"
            imageInputs={[
              { name: "faviconChanged", value: faviconChanged },
              {
                name: "formFaviconFile",
                value: formFavicon.file || "",
              },
              {
                name: "formFaviconType",
                value: formFavicon.type || "",
              },
              {
                name: "formFaviconName",
                value: formFavicon.name || "",
              },
              {
                name: "formFaviconS3Path",
                value: formFavicon.s3Path,
              },
            ]}
            imageDimensions={{
              marginTop: 0,
            }}
            buttonTitle={t("common:edit")}
            value={favicon}
            onChange={handleChange}
            showButton={false}
            toolTipTextBody={t("branding.maxSize800kbTooltip")}
          />
        </section>
      </article>
    </div>
  );
};
